import { createContext, useContext, useState, useCallback } from 'react';

const LangContext = createContext();

const t = {
  en: {
    // Header
    freeInspection: 'Free Inspection',
    callNow: 'Call Now',

    // Hero
    heroBadge: '40+ Years on the Central Coast',
    heroH1_1: 'Santa Maria CA',
    heroH1_2: 'Exhaust & Muffler Shop',
    heroSubtitle: 'Repair \u2022 Installation \u2022 Performance',
    heroSubhead: "Santa Maria's trusted exhaust & muffler shop since the '80s. Honest work, fair prices, and installs as fast as 35 minutes.",
    heroBullet1: 'Walk-Ins Welcome',
    heroBullet2: 'FREE Inspections',
    heroBullet3: 'Installs as Fast as 35 Min',
    heroBullet4: 'Military & Veteran Discounts',
    heroBullet5: 'Cars accepted until 4 PM (Mon\u2013Thu) & 2 PM (Fri)',
    heroCallCta: 'Got Questions? Call!! (805) 922-9684',
    heroDirectionsCta: 'Get Directions',

    // Lead Form
    leadTitle: 'FOR AN ESTIMATE YOU MUST CALL US OR VISIT US IN-PERSON!!',
    leadSubtitle1: '',
    leadSubtitle2: "Submit your info and message us :)\nWe'll guide you from there.",
    leadName: 'Full Name',
    leadNamePlaceholder: 'Your full name',
    leadEmail: 'Email Address',
    leadEmailPlaceholder: 'you@email.com',
    leadHeard: 'How did you hear about us?',
    leadHeardPlaceholder: 'Select one...',
    leadHeardReferral: 'Referral',
    leadHeardDrivingBy: 'Driving By',
    leadHeardOther: 'Other',
    leadSubmit: 'Submit & Message Us',
    leadSending: 'Sending...',
    leadError: 'Please fill in all fields.',
    leadErrorGeneric: 'Something went wrong. Please try again.',

    // TrustBar
    trustYears: 'Years on the\nCentral Coast',
    trustMinute: 'Minute\nInstalls',
    trustInspections: 'Inspections\nNo Pressure',
    trustSatisfaction: 'Satisfaction\nGuaranteed',

    // Services
    servicesLabel: 'What We Do',
    servicesTitle: 'Services That Perform',
    servicesSubtitle: "From a simple rattle fix to a full custom exhaust build \u2014 we've got you covered.",
    svc1Title: 'Performance Exhaust',
    svc1Desc: 'Deeper tone, more flow, real gains. Flowmaster, Borla, Magnaflow \u2014 we stock them all.',
    svc2Title: 'Custom Fabrication',
    svc2Desc: 'One-off builds, bent in-house. Your spec, our craft.',
    svc3Title: 'Catalytic Converters',
    svc3Desc: 'Pass smog, keep the power. Quality cats, expert installation.',
    svc4Title: 'Headers & Intakes',
    svc4Desc: 'Wake up your top end. K&N, AirAid, Gibson \u2014 installed right.',
    svc5Title: 'Tuning & Programmers',
    svc5Desc: 'Dialed in for your setup. Get every horse your engine has to offer.',
    svc6Title: 'Everyday Repair',
    svc6Desc: "Rattle, drone, or check engine light \u2014 we'll fix it fast and fairly.",

    // Why Us
    whyLabel: 'Why Choose Us',
    whyTitle: 'The Super Muffler Difference',
    why1Title: '40+ Years On The Central Coast',
    why1Body: "We've been serving Santa Maria and surrounding communities since the eighties. That's decades of trust, repeat customers, and a reputation we protect with every job.",
    why2Title: 'Every Major Brand In Stock',
    why2Body: "Flowmaster, Magnaflow, Borla, Dynomax, K&N, MBRP, and more. No waiting on orders \u2014 we keep the parts you need on the shelf.",
    why3Title: 'Built Right The First Time',
    why3Body: "Tight welds, proper fitment, and a satisfaction guarantee. We take pride in clean work that holds up \u2014 whether it's a daily driver or a dedicated performance build.",

    // Gallery
    galleryLabel: 'Our Work',
    galleryTitle: 'Builds We\'re Proud Of',
    gallerySubtitle: "Every job that leaves our shop meets our standard. Here's a look at recent work.",
    galCap1: 'Custom exhaust welding \u2014 in progress',
    galCap2: 'Expert muffler fitting & assembly',
    galCap3: 'Precision custom fabrication',
    galCap4: 'Undercarriage exhaust repair',
    galCap5: 'Performance exhaust routing',
    galCap6: 'Quality parts, every time',

    // Brands
    brandsLabel: 'Parts & Brands We Stock',
    brandsSubtitle: 'All major performance brands, on the shelf and ready to install.',

    // Testimonials
    testLabel: 'Customer Love',
    testTitle: 'What Our Customers Say',
    testSubtitle: 'Real people. Real cars. Real results.',

    // Military
    milTitle: 'Military & Veteran Discount',
    milBody: 'Ask at the counter and show your ID or DD-214. Thank you for your service.',
    milCta: 'Call to Ask',

    // Location
    locLabel: 'Find Us',
    locTitle: "We're in Santa Maria",
    locSubtitle: 'Walk-ins always welcome. No appointment needed.',
    locWalkIns: 'Walk-Ins Welcome \u2014 No Appointment Needed',
    locHours: 'Hours',
    locMonThu: 'Monday \u2013 Thursday',
    locFri: 'Friday',
    locSat: 'Saturday',
    locSun: 'Sunday',
    locClosed: 'Closed',
    locDirections: 'Get Directions',

    // Final CTA
    ctaLabel: 'Ready When You Are',
    ctaH2_1: 'Ready to Hear',
    ctaH2_2: 'the Difference?',
    ctaBody: "Call us, walk in, or just drive up. Free inspection, no pressure. We'll tell you exactly what you need \u2014 and nothing you don't.",
    ctaPhone: 'Call (805) 922-9684',
    ctaAddress: '926 W Main St, Santa Maria \u00B7 Mon\u2013Thu 8am\u20135pm \u00B7 Fri 8am\u20133pm',

    // Footer
    footerDesc: 'Performance exhaust & muffler specialists serving Santa Maria and the Central Coast since the 1980s.',
    footerContact: 'Contact',
    footerHours: 'Hours',
    footerMonThu: 'Mon \u2013 Thu: 8am \u2013 5pm',
    footerFri: 'Friday: 8am \u2013 3pm',
    footerWeekend: 'Sat \u2013 Sun: Closed',
    footerRights: 'All rights reserved.',
    footerPrivacy: 'Privacy Policy',

    // Mobile sticky
    stickyCall: 'Tap to Call \u2014 Free Inspection',

    // Social Section
    socialBadge: 'FOLLOW ALONG',
    socialTitle: 'See Us in Action',
    socialSubtitle: 'Follow Super Muffler on social media, leave a review, or find us on your favorite platform.',
    socialIgTitle: 'Instagram',
    socialIgHandle: '@supermufflerinc',
    socialIgDesc: 'See our latest builds, before & afters, and crew in action.',
    socialIgCta: 'FOLLOW US',
    socialFbTitle: 'Facebook',
    socialFbHandle: 'Super Muffler Inc.',
    socialFbDesc: 'Like our page for updates, tips, and community posts.',
    socialFbCta: 'LIKE OUR PAGE',
    socialGoogleTitle: 'Google Maps',
    socialGoogleHandle: 'Super Muffler Inc.',
    socialGoogleDesc: 'Leave a Google review \u2014 it helps our community find us.',
    socialGoogleCta: 'LEAVE A REVIEW',
    socialTtTitle: 'TikTok',
    socialTtHandle: '@supermuffler',
    socialTtDesc: 'Watch our exhaust builds and shop life videos.',
    socialTtCta: 'WATCH NOW',
    socialReviewTitle: 'Loved our service?',
    socialReviewBody: 'A quick review goes a long way for a family-owned business. We truly appreciate it!',
    socialReviewCta: 'LEAVE A GOOGLE REVIEW',

    // Thank You
    tyHeadline: "You're all set",
    tyBody: "For questions or next steps, choose a platform below and message us.\nWe'll respond and guide you from there.",
    tyInstagram: 'Message Us on Instagram',
    tyMessenger: 'Message Us on Messenger',
  },

  es: {
    // Header
    freeInspection: 'Inspecci\u00f3n Gratis',
    callNow: 'Llamar',

    // Hero
    heroBadge: '40+ A\u00f1os en la Costa Central',
    heroH1_1: 'Santa Maria CA',
    heroH1_2: 'Escape & Mofles',
    heroSubtitle: 'Reparaci\u00f3n \u2022 Instalaci\u00f3n \u2022 Rendimiento',
    heroSubhead: 'El taller de escape y mofles de confianza en Santa Maria desde los a\u00f1os 80. Trabajo honesto, precios justos e instalaciones en tan solo 35 minutos.',
    heroBullet1: 'Sin Cita Previa',
    heroBullet2: 'Inspecciones GRATIS',
    heroBullet3: 'Instalaciones en 35 Min',
    heroBullet4: 'Descuento Militar y Veteranos',
    heroBullet5: 'Autos aceptados hasta las 4 PM (Lun\u2013Jue) y 2 PM (Vie)',
    heroCallCta: '\u00bfPreguntas? \u00a1Llama!! (805) 922-9684',
    heroDirectionsCta: 'C\u00f3mo Llegar',

    // Lead Form
    leadTitle: '\u00a1PARA UN ESTIMADO DEBE LLAMARNOS O VISITARNOS EN PERSONA!!',
    leadSubtitle1: '',
    leadSubtitle2: 'Env\u00eda tu informaci\u00f3n y escr\u00edbenos :)\nTe guiaremos desde ah\u00ed.',
    leadName: 'Nombre Completo',
    leadNamePlaceholder: 'Tu nombre completo',
    leadEmail: 'Correo Electr\u00f3nico',
    leadEmailPlaceholder: 'tu@correo.com',
    leadHeard: '\u00bfC\u00f3mo te enteraste de nosotros?',
    leadHeardPlaceholder: 'Selecciona uno...',
    leadHeardReferral: 'Referido',
    leadHeardDrivingBy: 'Pasando por aqu\u00ed',
    leadHeardOther: 'Otro',
    leadSubmit: 'Enviar y Escr\u00edbenos',
    leadSending: 'Enviando...',
    leadError: 'Por favor completa todos los campos.',
    leadErrorGeneric: 'Algo sali\u00f3 mal. Int\u00e9ntalo de nuevo.',

    // TrustBar
    trustYears: 'A\u00f1os en la\nCosta Central',
    trustMinute: 'Minutos de\nInstalaci\u00f3n',
    trustInspections: 'Inspecciones\nSin Presi\u00f3n',
    trustSatisfaction: 'Satisfacci\u00f3n\nGarantizada',

    // Services
    servicesLabel: 'Lo Que Hacemos',
    servicesTitle: 'Servicios de Alto Rendimiento',
    servicesSubtitle: 'Desde una reparaci\u00f3n simple hasta una construcci\u00f3n completa de escape \u2014 te tenemos cubierto.',
    svc1Title: 'Escape de Rendimiento',
    svc1Desc: 'Tono m\u00e1s profundo, m\u00e1s flujo, ganancias reales. Flowmaster, Borla, Magnaflow \u2014 los tenemos todos.',
    svc2Title: 'Fabricaci\u00f3n a Medida',
    svc2Desc: 'Construcci\u00f3n \u00fanica, doblado en casa. Tu especificaci\u00f3n, nuestra artesano.',
    svc3Title: 'Convertidores Catal\u00edticos',
    svc3Desc: 'Pasa smog, mant\u00e9n la potencia. Cats de calidad, instalaci\u00f3n experta.',
    svc4Title: 'Headers y Admisi\u00f3n',
    svc4Desc: 'Despierta tu motor. K&N, AirAid, Gibson \u2014 instalados correctamente.',
    svc5Title: 'Afinaci\u00f3n y Programadores',
    svc5Desc: 'Ajustado para tu configuraci\u00f3n. Obt\u00e9n cada caballo que tu motor puede ofrecer.',
    svc6Title: 'Reparaci\u00f3n General',
    svc6Desc: 'Ruido, vibraci\u00f3n o luz de motor \u2014 lo arreglamos r\u00e1pido y a buen precio.',

    // Why Us
    whyLabel: 'Por Qu\u00e9 Elegirnos',
    whyTitle: 'La Diferencia Super Muffler',
    why1Title: '40+ A\u00f1os en la Costa Central',
    why1Body: 'Hemos estado sirviendo a Santa Maria y comunidades circundantes desde los ochenta. Son d\u00e9cadas de confianza, clientes recurrentes y una reputaci\u00f3n que protegemos con cada trabajo.',
    why2Title: 'Todas las Marcas en Stock',
    why2Body: 'Flowmaster, Magnaflow, Borla, Dynomax, K&N, MBRP y m\u00e1s. Sin esperar pedidos \u2014 tenemos las piezas que necesitas en el estante.',
    why3Title: 'Bien Hecho a la Primera',
    why3Body: 'Soldaduras fuertes, ajuste perfecto y garant\u00eda de satisfacci\u00f3n. Nos enorgullecemos del trabajo limpio que perdura \u2014 ya sea un auto diario o una construcci\u00f3n de rendimiento.',

    // Gallery
    galleryLabel: 'Nuestro Trabajo',
    galleryTitle: 'Trabajos de los que Estamos Orgullosos',
    gallerySubtitle: 'Cada trabajo que sale de nuestro taller cumple con nuestro est\u00e1ndar. Mira trabajos recientes.',
    galCap1: 'Soldadura de escape personalizado \u2014 en progreso',
    galCap2: 'Montaje y ensamble experto de mofle',
    galCap3: 'Fabricaci\u00f3n de precisi\u00f3n a medida',
    galCap4: 'Reparaci\u00f3n de escape bajo el auto',
    galCap5: 'Ruteo de escape de rendimiento',
    galCap6: 'Piezas de calidad, siempre',

    // Brands
    brandsLabel: 'Piezas y Marcas en Stock',
    brandsSubtitle: 'Todas las marcas principales de rendimiento, en el estante y listas para instalar.',

    // Testimonials
    testLabel: 'Amor del Cliente',
    testTitle: 'Lo que Dicen Nuestros Clientes',
    testSubtitle: 'Gente real. Autos reales. Resultados reales.',

    // Military
    milTitle: 'Descuento Militar y Veteranos',
    milBody: 'Preg\u00fanta en el mostrador y muestra tu identificaci\u00f3n o DD-214. Gracias por tu servicio.',
    milCta: 'Llamar para Preguntar',

    // Location
    locLabel: 'Enc\u00faentranos',
    locTitle: 'Estamos en Santa Maria',
    locSubtitle: 'Sin cita previa siempre bienvenido.',
    locWalkIns: 'Sin Cita Previa \u2014 Siempre Bienvenido',
    locHours: 'Horario',
    locMonThu: 'Lunes \u2013 Jueves',
    locFri: 'Viernes',
    locSat: 'S\u00e1bado',
    locSun: 'Domingo',
    locClosed: 'Cerrado',
    locDirections: 'C\u00f3mo Llegar',

    // Final CTA
    ctaLabel: 'Listos Cuando T\u00fa Lo Est\u00e9s',
    ctaH2_1: 'Listo para Escuchar',
    ctaH2_2: 'la Diferencia?',
    ctaBody: 'Ll\u00e1manos, ven sin cita, o simplemente maneja hasta aqu\u00ed. Inspecci\u00f3n gratis, sin presi\u00f3n. Te diremos exactamente lo que necesitas \u2014 y nada que no.',
    ctaPhone: 'Llamar (805) 922-9684',
    ctaAddress: '926 W Main St, Santa Maria \u00B7 Lun\u2013Jue 8am\u20135pm \u00B7 Vie 8am\u20133pm',

    // Footer
    footerDesc: 'Especialistas en escape y mofles de rendimiento sirviendo a Santa Maria y la Costa Central desde los 1980s.',
    footerContact: 'Contacto',
    footerHours: 'Horario',
    footerMonThu: 'Lun \u2013 Jue: 8am \u2013 5pm',
    footerFri: 'Viernes: 8am \u2013 3pm',
    footerWeekend: 'S\u00e1b \u2013 Dom: Cerrado',
    footerRights: 'Todos los derechos reservados.',
    footerPrivacy: 'Pol\u00edtica de Privacidad',

    // Mobile sticky
    stickyCall: 'Llama \u2014 Inspecci\u00f3n Gratis',

    // Social Section
    socialBadge: 'S\u00cdGUENOS',
    socialTitle: 'Mira Nuestro Trabajo',
    socialSubtitle: 'S\u00edguenos en redes sociales, deja una rese\u00f1a, o enc\u00faentranos en tu plataforma favorita.',
    socialIgTitle: 'Instagram',
    socialIgHandle: '@supermufflerinc',
    socialIgDesc: 'Mira nuestros \u00faltimos trabajos, antes y despu\u00e9s, y al equipo en acci\u00f3n.',
    socialIgCta: 'S\u00cdGUENOS',
    socialFbTitle: 'Facebook',
    socialFbHandle: 'Super Muffler Inc.',
    socialFbDesc: 'Dale like a nuestra p\u00e1gina para actualizaciones y publicaciones.',
    socialFbCta: 'DALE LIKE',
    socialGoogleTitle: 'Google Maps',
    socialGoogleHandle: 'Super Muffler Inc.',
    socialGoogleDesc: 'Deja una rese\u00f1a en Google \u2014 ayuda a nuestra comunidad a encontrarnos.',
    socialGoogleCta: 'DEJAR RESE\u00d1A',
    socialTtTitle: 'TikTok',
    socialTtHandle: '@supermuffler',
    socialTtDesc: 'Mira nuestros videos de construcciones de escape y vida en el taller.',
    socialTtCta: 'VER AHORA',
    socialReviewTitle: '\u00bfTe gust\u00f3 nuestro servicio?',
    socialReviewBody: 'Una rese\u00f1a r\u00e1pida ayuda mucho a un negocio familiar. \u00a1Lo apreciamos de verdad!',
    socialReviewCta: 'DEJAR RESE\u00d1A EN GOOGLE',

    // Thank You
    tyHeadline: 'Todo listo',
    tyBody: 'Para preguntas o pr\u00f3ximos pasos, elige una plataforma abajo y escr\u00edbenos.\nResponderemos y te guiaremos desde ah\u00ed.',
    tyInstagram: 'Escr\u00edbenos en Instagram',
    tyMessenger: 'Escr\u00edbenos en Messenger',
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('sm_lang') || 'en'; } catch { return 'en'; }
  });

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === 'en' ? 'es' : 'en';
      try { localStorage.setItem('sm_lang', next); } catch {}
      return next;
    });
  }, []);

  const setLanguage = useCallback((code) => {
    setLang(code);
    try { localStorage.setItem('sm_lang', code); } catch {}
  }, []);

  return (
    <LangContext.Provider value={{ lang, toggle, setLanguage, t: t[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
